// greeting-view.js

import $                    from 'jquery';
import { View } from 'backbone';
import contentTemplate      from 'greeting-view.ejs';
import formLoadService      from 'FormLoadService.js';
import notificationService      from 'NotificationService.js';
import constants            from 'Constants.js';
import listService          from 'ListService.js'
import RestService          from 'RestService.js'
import util                 from 'util/Util.js';
import { Model }            from 'backbone';
import eventBus             from 'EventBus';

class GreetingView extends View {

    initialize( opts ) {
        let $div = $('<div />').appendTo('body');
        $div.attr('id', 'hold-greeting');

        this.$el = $("#hold-greeting");


        this.options = opts || {};
        this.template = contentTemplate; 

        this.GettingStarted = listService._userSettings.get('_maShGS');
    }

    home() {
        Backbone.history.loadUrl('dashboard');
    }

    greetingExit() {
        Backbone.history.loadUrl('login');
    }

    new_form() {
        eventBus.trigger( constants.EV_NEW_PRIVATE_FORM );
    }

    openTestReport() {
        Backbone.history.loadUrl('testReport');
    }

    bindEvents() {
        let self = this;
        $('#greetingExit').on('click',(e) => {            
            self.removeModal();           
        });

        $('#home').on('click',(e) => {     
           self.removeModal();    
        });

        $('#home_image').on('click',(e) => {
           self.removeModal();   
        });

        $('#new_form').on('click',(e) => {
            self.removeModal();
            this.new_form();
        });

        $('#new_form_image').on('click',(e) => {
           self.removeModal();
           this.new_form();
        });

        $('#sample_form').on('click',(e) => {
            this.openSampleForm();
        });

        $('#sample_form_image').on('click',(e) => {
            this.openSampleForm();
        });

        $('#show_startup').on('change',(e) =>{
            const propVal  = e.currentTarget.checked;
            this.GettingStarted = propVal;
            listService._userSettings.set('_maShGS', propVal);
        });
    }

    openSampleForm(){
        const self = this;
        const errNotifyFn = () => {
            const sampleMsg = `An error occurred.\n\nThe Sample App is not available.\n\nContact your system administrator.`;
            notificationService.error(sampleMsg);
        };

        const sampleFormId = listService.userProfile.GettingStartedFormId;
        let sampleMajorVersion, sampleMinorVersion, sampleFormLinkId, sampleFormName, sampleFormVersionId;

        RestService.getFormDetails(sampleFormId).then((formDetailsResult) => {
            const formDetailsData=formDetailsResult.RESULT.RESPONSE.PrivateFormDetails;
            sampleFormName = formDetailsData.Name;
            sampleFormLinkId = formDetailsData.LinkId;
            const lastVersion = formDetailsData.VersionList.Version instanceof Array ? formDetailsData.VersionList.Version[0] : formDetailsData.VersionList.Version;
            sampleMajorVersion = lastVersion['@MajorVersion'];
            sampleMinorVersion = lastVersion['@MinorVersion'];
            sampleFormVersionId = lastVersion['@FormVersionId'];

        }).then (()=> {
            formLoadService.loadForm(
                sampleFormId,
                sampleMajorVersion,
                sampleMinorVersion,
                sampleFormLinkId,
                sampleFormName,
                sampleFormVersionId).then(msg => {

                // TODO Properly configure desktop for sample. The following throws an exception
                /*listService.dashboardLayout.leftPanelView.remove();
                listService.dashboardLayout.mainPanelView.remove();*/ 
 
                self.removeModal();

                
            }, (errMsg) => {
                console.log(errMsg);
                errNotifyFn();
            })
        }).catch((error) => {
            console.log(error);
            errNotifyFn();
        });
    }

    render() {
        this.$el.empty();    
        this.$el.append(this.template(this.model.toJSON()));
 
        // Show modal popup window

        //PF-10257 temporarily removed this code, this will be removed in different ticket
        // const dialog = $('#dialog-greeting' ).dialog({
        //     autoOpen: true,
        //     height: 'auto',
        //     width: 750,
        //     modal: true,
        //     resizable: false,
        //     buttons: [],
        //     dialogClass: 'dialog-container', 
        //     close: function( event, ui ) {
        //         let dialog = $( '#dialog-greeting' );
        //         if (dialog) {
        //             dialog.dialog( "close" );
        //             dialog.remove();
        //         }
        //         $("#hold-greeting").remove();
        //     }
        // }); 
        
        
        // $(".ui-dialog-titlebar").hide();

        //$('#show_startup').attr('checked', this.GettingStarted);

        this.bindEvents();

        return this;
    }

    removeModal() {
       $('#dialog-greeting').remove();
       $("#hold-greeting").remove();
       
       this.remove();       
    }
}

export default GreetingView;
